// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SideBar_mainContainer__jik9Z","logoContainer":"SideBar_logoContainer__71jt9","navContainer":"SideBar_navContainer__1OeOb"};